<template>
  <v-container-principal>
    <template #header>
      <v-cabecalho
        nomePagina="Nova reserva"
        buscaPlaceHolder="Pesquisar por uma Sala"
        backTo="/"
        :search="selecao.textoPesquisado"
        v-on:search="(value) => (selecao.textoPesquisado = value)">
      </v-cabecalho>
    </template>

    <template #filter>
      <v-filtro>
        <template v-slot:filterData>
          <v-menu
            ref="menuData"
            :close-on-content-click="false"
            :nudge-right="40"
            max-width="290px"
            min-width="290px"
            offset-y
            transition="scale-transition">
            <template v-slot:activator="{ on }">
              <v-text-field
                label="Data"
                readonly
                hint="Obrigatório"
                v-on="on"
                @change="loadSalasAndUpdateURL"
                v-model="intervaloDatas"></v-text-field>
            </template>
            <v-tabs grow v-model="tabDatas">
              <v-tab key="0">Data Inicial</v-tab>
              <v-tab key="1">Data Final</v-tab>
              <v-tab-item key="0">
                <v-date-picker
                  full-width
                  v-model="selecao.dataDeInicio"
                  :min="dataDeInicioMinima"
                  @click:date="changeDataTab"
                  color="primary"></v-date-picker>
              </v-tab-item>
              <v-tab-item key="1">
                <v-date-picker
                  full-width
                  v-model="selecao.dataDeTermino"
                  :min="selecao.dataDeInicio"
                  color="primary"
                  @click:date="closeDataTab"></v-date-picker>
              </v-tab-item>
            </v-tabs>
          </v-menu>
        </template>
        <template v-slot:filterHorario>
          <v-menu
            ref="menuHorario"
            :close-on-content-click="false"
            :nudge-right="40"
            max-width="290px"
            min-width="290px"
            offset-y
            transition="scale-transition">
            <template v-slot:activator="{ on }">
              <v-text-field
                label="Horário"
                readonly
                hint="Obrigatório"
                v-on="on"
                @change="loadSalasAndUpdateURL"
                v-model="intervaloHorario"></v-text-field>
            </template>
            <v-tabs grow v-model="tabHorarios">
              <v-tab key="0">Hora Inicial</v-tab>
              <v-tab key="1">Hora Final</v-tab>
              <v-tab-item key="0">
                <v-time-picker
                  format="24hr"
                  full-width
                  locale="brazil"
                  v-model="selecao.horarioDeInicio"
                  @click:minute="changeHorarioTab"
                  color="primary"></v-time-picker>
              </v-tab-item>
              <v-tab-item key="1">
                <v-time-picker
                  format="24hr"
                  full-width
                  v-model="selecao.horarioDeTermino"
                  :min="selecao.horarioDeInicio"
                  @click:minute="closeHorarioTab"
                  color="primary"></v-time-picker>
              </v-tab-item>
            </v-tabs>
          </v-menu>
        </template>
        <template v-slot:filterDias>
          <v-select
            multiple
            hint="Obrigatório"
            v-model="selecao.dias"
            label="Dias da semana"
            @input="loadSalasAndUpdateURL"
            :items="diasDisponiveis"
            :disabled="!escolheuPeriodo"></v-select>
        </template>
        <template v-slot:filterBlocos>
          <v-select
            clearable
            v-model="selecao.bloco"
            label="Todos os blocos"
            @click:clear="selecao.andar = ''"
            @input="loadSalasAndUpdateURL"
            :items="nomeDosBlocos"
            :disabled="!escolheuPeriodo"></v-select>
        </template>
        <template v-slot:filterAndar>
          <v-select
            clearable
            v-model="selecao.andar"
            label="Todos os Pisos"
            @input="loadSalasAndUpdateURL"
            :items="todosOsAndares"
            :disabled="!escolheuPeriodo"></v-select>
        </template>
        <template v-slot:filterCapacidade>
          <v-text-field
            type="number"
            min="1"
            v-model="selecao.capacidade"
            label="Capacidade"
            @input="loadSalasAndUpdateURL"
            :disabled="!escolheuPeriodo"></v-text-field>
        </template>
        <template v-slot:filterComputadores>
          <v-text-field
            type="number"
            min="0"
            v-model="selecao.computadores"
            label="Nº de Computadores"
            @input="loadSalasAndUpdateURL"
            :disabled="!escolheuPeriodo"></v-text-field>
        </template>
        <template v-slot:filterEquipamentos>
          <v-select
            multiple
            v-model="selecao.equipamentos"
            label="Equipamento"
            @change="loadSalasAndUpdateURL"
            :items="todosOsEquipamentos"
            :disabled="!escolheuPeriodo">
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                {{ item }}
              </v-chip>
              <span v-if="index === 1" class="grey--text text-caption">
                +{{ selecao.equipamentos.length - 1 }} outros</span
              >
            </template>
          </v-select>
        </template>
      </v-filtro>
    </template>

    <div>
      <template v-if="filtrosVazios">
        <div class="text-center text-h5">
          Os campos <mark>data</mark>, <mark>horário</mark> e os
          <mark>dias desejados</mark> são <mark>obrigatórios</mark> para
          verificarmos as salas disponíveis.
          <v-img
            class="mt-4 mx-auto"
            max-width="30%"
            max-height="30%"
            position="center center"
            src="../../assets/Ilustracao-login.png"></v-img>
        </div>
      </template>
      <template v-else>
        <v-data-iterator
          :items="salasFiltradas"
          no-data-text="Nenhuma sala atende os requisitos da sua solicitação de reserva."
          :search="procurarSalaPorNome">
          <template v-slot:default="props">
            <v-row>
              <v-col
                v-for="item in props.items"
                :key="item.id"
                cols="12"
                md="6">
                <v-card-sala
                  :id="item.id"
                  :nome="item.nome"
                  :capacidade="item.capacidade"
                  :computadores="item.computadores"
                  :localizacaosala="item.descricao"
                  :localizacaoandar="item.andar"
                  :mesa="item.mesa"
                  :projetor="item.projetor"
                  :arcondicionado="item.arcondicionado"
                  :lousa="item.lousa"
                  :color="
                    item.id === reserva.sala ? 'orange lighten-3' : undefined
                  "
                  enableHeader>
                  <v-btn
                    class="button-card text-capitalize mr-1 ml-2"
                    color="primary"
                    min-width="80px"
                    @click="showDialog(item)"
                    >Reservar</v-btn
                  >
                </v-card-sala>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </template>
    </div>

    <v-dialog v-model="reservaDialog" max-width="800px">
      <v-card
        class="rounded-lg pa-md-9 pa-4 pt-0 pt-md-0 primary-border"
        v-if="salaSelecionada">
        <v-card-title
          class="text-center primary--text font-weight-bold text-md-h4 text-h6 d-block">
          Dados da Reserva
          <v-btn icon @click="closeDialog" class="float-end">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-alert
          v-if="salaSelecionada.id === reserva.sala"
          border="top"
          color="orange darken-3"
          dark>
          A sala escolhida é a mesma que foi selecionada anteriormente.
        </v-alert>
        <v-row>
          <v-col md="6" sm="12">
            <v-card class="rounded-lg px-5 primary-border">
              <div class="pt-3">
                <h2>{{ salaSelecionada.nome }}</h2>
                <h3 class="font-weight-regular">
                  {{ salaSelecionada.descricao }}, {{ salaSelecionada.andar }}º
                  piso
                </h3>
                <h4 class="font-weight-regular">
                  <v-icon> groups </v-icon>
                  {{ salaSelecionada.capacidade }} lugares
                </h4>

                <h3 class="mt-4 font-weight-regular">Período</h3>
                <v-row>
                  <v-col md="5">
                    <v-textarea
                      class="rounded-lg"
                      dense
                      auto-grow
                      rows="1"
                      outlined
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      :value="dataDeInicio"></v-textarea>
                  </v-col>
                  <v-col col="2" class="text-center"> até </v-col>
                  <v-col md="5">
                    <v-textarea
                      class="rounded-lg"
                      rows="1"
                      prepend-inner-icon="mdi-calendar"
                      auto-grow
                      dense
                      outlined
                      readonly
                      :value="dataDeTermino"></v-textarea>
                  </v-col>
                </v-row>

                <h3 class="font-weight-regular">Horário</h3>
                <v-row>
                  <v-col md="5">
                    <v-textarea
                      class="rounded-lg"
                      rows="1"
                      prepend-inner-icon="mdi-clock"
                      auto-grow
                      dense
                      outlined
                      readonly
                      :value="selecao.horarioDeInicio"></v-textarea>
                  </v-col>
                  <v-col col="2" class="text-center"> até </v-col>
                  <v-col md="5">
                    <v-textarea
                      class="rounded-lg"
                      rows="1"
                      prepend-inner-icon="mdi-clock"
                      auto-grow
                      dense
                      outlined
                      readonly
                      :value="selecao.horarioDeTermino"></v-textarea>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col col="6" md="12">
                    <h3 class="font-weight-regular">Repete</h3>
                    <v-chip-group>
                      <v-chip
                        v-for="dia in selecao.dias"
                        :key="dia"
                        :value="dia"
                        x-small>
                        {{ dia }}
                      </v-chip>
                    </v-chip-group>
                  </v-col>
                  <v-col col="6" md="12">
                    <h3 class="font-weight-regular">Equipamentos</h3>
                    <v-card class="mx-auto mb-2 rounded-lg" outlined>
                      <ul>
                        <li
                          v-for="equipamento in todosOsEquipamentos"
                          :key="equipamento"
                          :class="{
                            'text-decoration-line-through':
                              !salaSelecionada[
                                equipamento
                                  .toLocaleLowerCase()
                                  .replaceAll(' ', '')
                              ],
                          }">
                          {{ equipamento }}
                        </li>
                      </ul>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
          <v-col md="6" sm="12">
            <div>
              <span class="primary--text text-h6">Usuário reponsável</span>
              <v-autocomplete
                label="Insira um responsável"
                v-model="reserva.responsavel"
                :items="possiveisResponsaveis"
                :debounce="500"
                :search-input.sync="buscaResponsavel">
              </v-autocomplete>
            </div>
            <div>
              <span class="primary--text text-h6">Nome da Reserva</span>
              <v-text-field
                class="rounded-lg"
                dense
                outlined
                v-model="reserva.titulo"></v-text-field>
            </div>
            <div>
              <span class="primary--text text-h6">Observações</span>
              <v-textarea
                class="rounded-lg"
                dense
                outlined
                height="180px"
                rows="6"
                placeholder="Insira aqui informações adicionais como os nomes e matrículas dos alunos participantes"
                v-model="reserva.justificativa"></v-textarea>
            </div>
            <v-row no-gutters>
              <v-col>
                <v-btn plain class="text-capitalize" @click="closeDialog"
                  >Cancelar</v-btn
                >
              </v-col>
              <v-col>
                <v-btn
                  color="primary"
                  class="text-capitalize"
                  @click="solicitarReserva">
                  Enviar Solicitação
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container-principal>
</template>

<script>
import dayjs from "dayjs"
import VContainerPrincipal from "../../components/VContainerPrincipal"
import VCabecalho from "../../components/VCabecalho"
import VFiltro from "../../components/VFiltro"
import VCardSala from "../../components/VCardSala"
import blocoRepository from "@/repositories/blocoRepository"
import salaRepository from "../../repositories/salaRepository"
import userRepository from "../../repositories/usuarioRepository"
import reservaRepository from "../../repositories/reservaRepository"
import { mapGetters, mapActions } from "vuex"

const PREENCHA_OS_CAMPOS_OBRIGATORIOS = "Preencha todos os campos."

export default {
  components: {
    VContainerPrincipal,
    VCabecalho,
    VFiltro,
    VCardSala,
  },
  props: ["id"],

  data: () => ({
    name: "SolicitarReserva",
    diasDaSemana: [
      "Domingo",
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
      "Sábado",
    ],
    todosOsBlocos: [],
    todosOsEquipamentos: ["Projetor", "Ar Condicionado", "Lousa", "Mesa"],
    selecao: {
      textoPesquisado: "",
      capacidade: "",
      computadores: "",
      andar: "",
      bloco: "",
      equipamentos: [],
      dataDeInicio: "",
      dataDeTermino: "",
      horarioDeInicio: "",
      horarioDeTermino: "",
      dias: [],
    },
    procurarSalaPorNome: "",
    salasDisponiveis: [],
    salaSelecionada: null,
    reservaDialog: false,
    reserva: {
      responsavel: null,
      titulo: "",
      justificativa: "",
    },
    possiveisResponsaveis: [],
    tabDatas: 0,
    tabHorarios: 0,
    buscaResponsavel: null,
    dataDeInicioMinima: dayjs().format("YYYY-MM-DD"),
  }),
  async mounted() {
    const response = await blocoRepository.getAll()
    this.todosOsBlocos = response.data.data

    if (!Array.isArray(this.selecao.dias)) {
      this.selecao.dias = [this.selecao.dias]
    }
    if (!Array.isArray(this.selecao.equipamentos)) {
      this.selecao.equipamentos = [this.selecao.equipamentos]
    }

    if (this.id) {
      const res = await reservaRepository.getOne(this.id)
      const reserva = res.data.data.attributes

      if (
        reserva.status === "Confirmado" ||
        (this.userId != reserva.responsavel.data.id && !this.isAdministrador)
      ) {
        this.$router.replace({ name: "acessoNegado" })
      }

      this.reserva = {
        responsavel: reserva.responsavel.data.id,
        titulo: reserva.titulo,
        status: "PENDENTE",
        justificativa: reserva.justificativa,
        sala: reserva.sala.data.id,
        data_inicio: reserva.data_inicio,
        data_termino: reserva.data_termino,
        horario_inicio: reserva.horario_inicio,
        horario_termino: reserva.horario_termino,
        dias: reserva.dias,
        capacidade: reserva.capacidade,
        participantes: reserva.participantes,
        computadores: reserva.computadores,
        arcondicionado: reserva.arcondicionado,
        projetor: reserva.projetor,
        mesa: reserva.mesa,
        lousa: reserva.lousa,
      }

      this.salaSelecionada = { id: reserva.sala.data.id }
      this.selecao = {
        textoPesquisado: "",
        capacidade: reserva.participantes,
        computadores: reserva.computadores,
        andar: reserva.sala.data.attributes.andar,
        bloco: reserva.sala.data.attributes.bloco.data.attributes.descricao,
        dataDeInicio: reserva.data_inicio,
        dataDeTermino: reserva.data_termino,
        equipamentos: [],
        horarioDeInicio: dayjs(reserva.horario_inicio, "HH:mm:ss").format(
          "HH:mm"
        ),
        horarioDeTermino: dayjs(reserva.horario_termino, "HH:mm:ss").format(
          "HH:mm"
        ),
        dias: reserva.dias.map((d) => d.dia),
      }

      for (let equipamento of this.todosOsEquipamentos) {
        if (reserva[equipamento.toLocaleLowerCase().replaceAll(" ", "")])
          this.selecao.equipamentos.push(equipamento)
      }
      this.selecao = Object.assign({}, this.$route.query, this.selecao)
    } else {
      this.reserva.responsavel = this.userId
      this.selecao = Object.assign(this.selecao, this.$route.query)
    }

    this.loadSalasAndUpdateURL()
    this.getResponsavel()
  },
  methods: {
    getResponsavel(responsavel) {
      if (this.isAdministrador) {
        userRepository.getAllByName(responsavel).then((res) => {
          this.possiveisResponsaveis = res.map((usuario) => ({
            text: usuario.username,
            value: usuario.id,
          }))
        })
      } else {
        this.possiveisResponsaveis = [{ value: this.userId, text: this.nome }]
      }
    },

    formatDate(date) {
      if (!date) return ""
      const [month, day] = date.split("-").splice(-2)
      return `${day}/${month}`
    },
    ePeriodoUmDia(dataInicial, dataFinal) {
      return dayjs(dataFinal).isSame(dataInicial)
    },
    periodoMaiorUmaSemana(dataInicio, dataFinal) {
      return dayjs(dataFinal).diff(dataInicio, "days") >= 6
    },
    async loadSalasDisponiveis() {
      if (!this.filtrosVazios) {
        const selecaoFormatada = { ...this.selecao }

        selecaoFormatada.dias = Array.isArray(selecaoFormatada.dias)
          ? selecaoFormatada.dias.join(",")
          : selecaoFormatada.dias
        selecaoFormatada.horarioDeInicio = `${selecaoFormatada.horarioDeInicio}:10`
        selecaoFormatada.horarioDeTermino = `${selecaoFormatada.horarioDeTermino}:00`
        if (selecaoFormatada.equipamentos) {
          selecaoFormatada.equipamentos = selecaoFormatada.equipamentos
            .map((e) => e.toLocaleLowerCase().replaceAll(" ", ""))
            .join(",")
        }
        const blocoSelecionado = this.todosOsBlocos.find(
          (b) => b.attributes.descricao === selecaoFormatada.bloco
        )
        selecaoFormatada.bloco = blocoSelecionado ? blocoSelecionado.id : ""

        try {
          const response = await salaRepository.disponiveis(selecaoFormatada)
          this.salasDisponiveis = response.data.data
        } catch (e) {
          if (e.isAxiosError) {
            this.showErro(e.response.data.error.message)
          } else {
            this.showErro(e.message)
          }
        }
      }
    },
    async loadSalasAndUpdateURL() {
      await this.loadSalasDisponiveis()
      this.$router.replace({ query: { ...this.selecao } })
    },
    showDialog(item) {
      this.salaSelecionada = item
      this.reservaDialog = true
    },
    closeDialog() {
      this.salaSelecionada = null
      this.reservaDialog = false
    },
    changeDataTab() {
      this.tabDatas = 1
    },
    closeDataTab() {
      this.tabDatas = 0
      this.$refs.menuData.save(this.intervaloDatas)
    },
    changeHorarioTab() {
      this.tabHorarios = 1
    },
    closeHorarioTab() {
      this.tabHorarios = 0
      this.$refs.menuHorario.save(this.intervaloHorario)
    },
    async solicitarReserva() {
      if (
        !this.reserva.responsavel ||
        !this.reserva.titulo ||
        !this.reserva.justificativa
      ) {
        this.showErro(PREENCHA_OS_CAMPOS_OBRIGATORIOS)
      } else {
        try {
          const payload = this.generatePayload()
          if (this.id) {
            await reservaRepository.update(this.id, payload)
          } else {
            await reservaRepository.create(payload)
          }
          this.$router.push({ name: "reservas" })
          this.showSucesso("Solicitação de reserva enviada")
        } catch (error) {
          this.showErro(error.response.data.error.message)
        }
      }
    },
    generatePayload() {
      return {
        data: {
          responsavel: this.reserva.responsavel,
          titulo: this.reserva.titulo,
          justificativa: this.reserva.justificativa,
          participantes:
            this.selecao.capacidade === ""
              ? 1
              : Number(this.selecao.capacidade),
          computadores:
            this.selecao.computadores === ""
              ? 0
              : Number(this.selecao.computadores),
          arcondicionado: this.selecao.equipamentos.includes("Ar Condicionado"),
          projetor: this.selecao.equipamentos.includes("Projetor"),
          mesa: this.selecao.equipamentos.includes("Mesa"),
          lousa: this.selecao.equipamentos.includes("Lousa"),
          sala: this.salaSelecionada.id,
          status: this.isAdministrador ? "Confirmado" : "Pendente",
          data_inicio: this.selecao.dataDeInicio,
          data_termino: this.selecao.dataDeTermino,
          horario_inicio: this.selecao.horarioDeInicio + ":10",
          horario_termino: this.selecao.horarioDeTermino + ":00",
          dias: this.selecao.dias.map((d, index) => {
            return { dia: d, id: index }
          }),
        },
      }
    },
    ...mapActions("message", ["showSucesso", "showErro"]),
  },
  computed: {
    salasFiltradas() {
      if (!this.filtrosVazios) {
        return this.salasDisponiveis.filter((sala) =>
          sala.nome
            .toLocaleLowerCase()
            .includes(this.selecao.textoPesquisado.toLocaleLowerCase())
        )
      }
      return this.salasDisponiveis
    },
    filtrosVazios() {
      const {
        dataDeInicio,
        dataDeTermino,
        horarioDeInicio,
        horarioDeTermino,
        dias,
      } = this.selecao
      return !(
        horarioDeInicio &&
        horarioDeTermino &&
        dataDeInicio &&
        dataDeTermino &&
        dias &&
        dias.length > 0
      )
    },
    nomeDosBlocos() {
      return this.todosOsBlocos.map((bloco) => bloco.attributes.descricao)
    },
    todosOsAndares() {
      const blocosSelecionado = this.selecao.bloco
      const blocosConsiderados = blocosSelecionado
        ? [
            this.todosOsBlocos.find(
              (bloco) => bloco.attributes.descricao === blocosSelecionado
            ),
          ]
        : this.todosOsBlocos

      if (blocosConsiderados.length > 0) {
        const andares = blocosConsiderados.map(
          (bloco) => bloco.attributes.quantidadeAndar
        )
        const maxAndar = Math.max(...andares)
        return [...Array(maxAndar + 1).keys()].splice(1)
      }
      return []
    },
    dataDeInicio() {
      return this.formatDate(this.selecao.dataDeInicio)
    },
    dataDeTermino() {
      return this.formatDate(this.selecao.dataDeTermino)
    },
    intervaloDatas() {
      return this.dataDeInicio && this.dataDeTermino
        ? `${this.dataDeInicio} até ${this.dataDeTermino}`
        : ""
    },
    intervaloHorario() {
      return this.selecao.horarioDeInicio && this.selecao.horarioDeTermino
        ? `${this.selecao.horarioDeInicio} até ${this.selecao.horarioDeTermino}`
        : ""
    },
    escolheuPeriodo() {
      return (
        this.selecao.horarioDeInicio &&
        this.selecao.horarioDeTermino &&
        this.selecao.dataDeInicio &&
        this.selecao.dataDeTermino
      )
    },
    diasDisponiveis() {
      const { dataDeInicio, dataDeTermino } = this.selecao
      if (this.periodoMaiorUmaSemana(dataDeInicio, dataDeTermino)) {
        return this.diasDaSemana
      } else if (this.ePeriodoUmDia(dataDeInicio, dataDeTermino)) {
        return [this.diasDaSemana[new Date(dataDeInicio).getUTCDay()]]
      } else {
        const diasPossiveis = []
        let faixaDeDias = dayjs(dataDeTermino).diff(dataDeInicio, "days")
        do {
          const aux = (new Date(dataDeInicio).getUTCDay() + faixaDeDias) % 7
          diasPossiveis.unshift(this.diasDaSemana[aux])
          faixaDeDias--
        } while (faixaDeDias >= 0)
        return diasPossiveis
      }
    },
    ...mapGetters({
      nome: ["auth/username"],
      userId: ["auth/userId"],
      isAdministrador: ["auth/isAdministrador"],
    }),
  },
  watch: {
    "selecao.dataInicio"(nova) {
      const { dataDeInicio, dataDeTermino } = this.selecao
      if (dayjs(dataDeInicio).isAfter(dataDeTermino)) {
        this.selecao.dataDeTermino = nova
      }
    },
    "selecao.textoPesquisado"() {
      this.$router.replace({ query: { ...this.selecao } })
    },
    buscaResponsavel(resp) {
      this.getResponsavel(resp)
    },
  },
}
</script>

<style scoped>
.primary-border {
  border: 2px solid rgb(8, 70, 142);
}
.v-tab {
  text-transform: none !important;
}

mark {
  font-weight: bold;
  color: #575e8e;
  background-color: transparent;
}
</style>
